import React from 'react'

import {
  ArrowRightIcon,
  CoinsEuroLineIcon,
  IconSizes,
  IconWeight,
  IdCardLineIcon,
  MoneyBagEuroLineIcon
} from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepTwo.module.scss'
import { TourInsight } from './FullTourStepTwo.types'

const INSIGHT_ICONS = [CoinsEuroLineIcon, MoneyBagEuroLineIcon, IdCardLineIcon]

export const FullTourStepTwo = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_two'
  })
  const pathChips = t('path_chips', { returnObjects: true }) as string[]
  const insights = t('insights', { returnObjects: true }) as TourInsight[]

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-two-title'
      aria-describedby='full-tour-step-two-description'
    >
      <div className={styles.tourCardContent}>
        <div className={styles.tourMain}>
          <div className={styles.tourLeft}>
            <div className={styles.tourHeading}>
              <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
              <h1 id='full-tour-step-two-title' className={styles.tourTitle}>
                <span>{t('title_before')}</span>
                <span className={styles.titleHighlight}>
                  {t('title_highlighted')}
                </span>
              </h1>
            </div>

            <div className={styles.tourDetails}>
              <nav className={styles.path} aria-label={t('path_label')}>
                {pathChips.map((chip, index) => (
                  <React.Fragment key={chip}>
                    {index > 0 && (
                      <ArrowRightIcon
                        aria-hidden='true'
                        color='var(--white)'
                        size={IconSizes.Size16}
                      />
                    )}
                    <span className={styles.pathChip}>{chip}</span>
                  </React.Fragment>
                ))}
              </nav>

              <div
                id='full-tour-step-two-description'
                className={styles.tourDescription}
              >
                <strong>{t('description_lead')}</strong>
                <span>{t('description_body')}</span>
              </div>
            </div>
          </div>

          <div className={styles.insights}>
            {insights.map((insight, index) => {
              const Icon = INSIGHT_ICONS[index] ?? CoinsEuroLineIcon
              return (
                <div key={insight.title} className={styles.insight}>
                  <div className={styles.insightIcon}>
                    <Icon
                      aria-hidden='true'
                      color='currentColor'
                      size={IconSizes.Size24}
                      weight={IconWeight.Regular}
                    />
                  </div>
                  <div className={styles.insightBody}>
                    <h2>{insight.title}</h2>
                    <p>{insight.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
